module.exports = __webpack_public_path__ + "img/requirementResearch.dcd13738.svg";